<div class="background-page">
  @if (showBrowserIncompatableMsg) {
  <div class="browser-incompatable-header">
    <span class="browser-incompatable-text">{{
      "BROWSER_INCOMPATABLE_TEXT" | globalTranslate
    }}</span
    >,
    <a
      class="btn-link cursor-hand"
      tabindex="0"
      (click)="showbrowserIncompatablePopup()"
    >
      <span class="pe-2 popup">{{ "CLICK_HERE" | globalTranslate }}</span>
    </a>
  </div>
  }
  <div class="p-5 mb-4 rounded-0 tenncare-background">
    <div class="container">
      <div class="row pe-5 py-5" style="padding-left: 2.3rem">
        <div class="page-info col-md-6">
          <h1 class="welcome-title">{{ "WELCOME_TITLE" | globalTranslate }}</h1>
          <div class="before-border ms-1">
            <p class="small ps-2 welcome-sub-head">
              {{ "WELCOME_DESC" | globalTranslate }}
            </p>
            <p class="small ps-2 welcome-body">
              {{ "WELCOME_DESC2" | globalTranslate }}.
            </p>
          </div>
          <div class="row ms-1 pb-3 pt-2">
            <button
              [routerLink]="['/', 'create-account']"
              class="btn btn-secondary col-md-6"
            >
              {{ "WELCOME_BTN" | globalTranslate }}
            </button>
          </div>
        </div>
        <div class="ml-md-4 col-md-5">
          <img
            class="bike-image img-responsive"
            src="../../../assets/images/welcome_page/WelcomePage_5.jpg"
            alt="welcome image"
            width="110%"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="container my-5 hor">
    <div class="row justify-content-center">
      <div class="col-md-4 px-box">
        <img
          alt="Apply coverage"
          class="apply-coverage-image img-responsive"
          src="../../../assets/images/Icons/apply_for_coverage.svg"
        />
        <h2 class="section-header mt-2 mb-3 px-box">
          {{ "WELCOME_APPLY_COVERAGE_HEADER" | globalTranslate }}
        </h2>
        <hr class="px-box-none" />
        <p class="small mt-3 px-box">
          <span class="visually-hidden">{{
            "WELCOME_APPLY_COVERAGE_ARIA" | globalTranslate
          }}</span>
          <span aria-hidden="true">{{
            "WELCOME_APPLY_COVERAGE" | globalTranslate
          }}</span>
        </p>
      </div>
      <div class="col-md-4 px-box">
        <img
          alt="Manage coverage"
          class="apply-coverage-image img-responsive"
          src="../../../assets/images/Icons/manage_coverage.svg"
        />
        <h2 class="section-header mt-2 mb-3 px-box">
          {{ "WELCOME_MANAGE_COVERAGE_HEADER" | globalTranslate }}
        </h2>
        <hr class="px-box-none" />
        <p class="small mt-3">
          {{ "WELCOME_MANAGE_COVERAGE" | globalTranslate }}
        </p>
      </div>
      <div class="col-md-4 px-box">
        <img
          alt="Upload Docs"
          class="apply-coverage-image img-responsive"
          src="../../../assets/images/Icons/upload_documents.svg"
        />
        <h2 class="section-header mt-2 mb-3 px-box">
          {{ "WELCOME_MANAGE_UPLOAD_HEADER" | globalTranslate }}
        </h2>
        <hr class="px-box-none" />
        <p class="small mt-3">
          {{ "WELCOME_MANAGE_UPLOAD" | globalTranslate }}
        </p>
      </div>
    </div>
  </div>
  <div class="carousel-holder">
    <div class="container">
      <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
        <ol class="carousel-indicators">
          <li
            data-bs-target="#myCarousel"
            data-bs-slide-to="0" [ngClass]="{ active: slide == 1 }"
          ></li>
          <li
            data-bs-target="#myCarousel"
            data-bs-slide-to="1" [ngClass]="{ active: slide == 2 }"
          ></li>
          <li
            data-bs-target="#myCarousel"
            data-bs-slide-to="2" [ngClass]="{ active: slide == 3 }"
          ></li>
          <li
            data-bs-target="#myCarousel"
            data-bs-slide-to="3" [ngClass]="{ active: slide == 4 }"
          ></li>
          <li
            data-bs-target="#myCarousel"
            data-bs-slide-to="4" [ngClass]="{ active: slide == 5 }"
          ></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item" [ngClass]="{ active: slide == 1 }">
            <img
              class="d-block slide-images"
              src="../../../assets/images/welcome_page/WelcomePage_1.jpg"
              alt="First slide"
            />
          </div>
          <div class="carousel-item" [ngClass]="{ active: slide == 2 }">
            <img
              class="d-block slide-images"
              src="../../../assets/images/welcome_page/WelcomePage_2.jpg"
              alt="Second slide"
              width="1200"
              height="auto"
            />
          </div>
          <div class="carousel-item" [ngClass]="{ active: slide == 3 }">
            <img
              class="d-block slide-images"
              src="../../../assets/images/welcome_page/WelcomePage_3.jpg"
              alt="Third slide"
              width="1200"
              height="auto"
            />
          </div>
          <div class="carousel-item" [ngClass]="{ active: slide == 4 }">
            <img
              class="d-block slide-images"
              src="../../../assets/images/welcome_page/WelcomePage_4.jpg"
              alt="Fourth slide"
              width="1200"
              height="auto"
            />
          </div>
          <div class="carousel-item" [ngClass]="{ active: slide == 5 }">
            <img
              class="d-block slide-images"
              src="../../../assets/images/welcome_page/WelcomePage_5.jpg"
              alt="Fifth slide"
            />
          </div>
        </div>
        <a
          class="carousel-control-prev"
          (click)="prevSlide()"
          role="button"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          (click)="nextSlide()"
          role="button"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
      </div>
    </div>
  </div>
  <div class="mt-5 card background-tenncare">
    <div class="card-body">
      <div class="container px-md-5 px-3 py-3">
        <div
          class="row justify-content-center align-items-center text-start text-md-left"
        >
          <!-- change text-center to text-start -->
          <h2 class="bg-user col-lg-12 mb-4">
            {{ "FOOTER-MOBILE-APP-TITLE" | globalTranslate }}
          </h2>
          <div class="col-lg-3 col-md-4">
            <div class="affirmation-cirlce">
              <div class="circle"></div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="pt-3 pt-md-0">
              <div class="before-border ms-1">
                <p class="small text-white ps-2">
                  {{ "FOOTER-MOBILE-APP-SUB-HEAD1" | globalTranslate }}
                  <br /><br />
                  {{ "FOOTER-MOBILE-APP-SUB-HEAD2" | globalTranslate }}
                </p>
              </div>
              <div class="row ms-1 pb-3 pt-2">
                <div class="col-md-6">
                  <a
                    class="small page-info btn-link"
                    href="https://apps.apple.com/us/app/tenncare/id1435791637"
                    target="_blank"
                    title="Download on the App Store"
                    role="link"
                  >
                    <span class="visually-hidden">{{
                      "FOOTER-APP-STORE-TEXT" | globalTranslate
                    }}</span>
                    <span aria-hidden="true">
                      <img
                        alt=""
                        class="img-responsive ps-1"
                        src="../../../assets/images/Icons/icons-logos-apple-appstore.svg"
                      />
                      <span class="footer-app-store-text">{{
                        "FOOTER-APP-STORE-TEXT" | globalTranslate
                      }}</span>
                    </span>
                  </a>
                </div>
                <div class="col-md-6">
                  <a
                    class="small page-info btn-link"
                    href="https://play.google.com/store/apps/details?id=gov.tn.teds"
                    target="_blank"
                    title="Get it on Google Play"
                    role="link"
                  >
                    <span class="visually-hidden">{{
                      "FOOTER-PLAY-STORE-TEXT" | globalTranslate
                    }}</span>
                    <span aria-hidden="true">
                      <img
                        alt=""
                        class="img-responsive ps-1"
                        src="../../../assets/images/Icons/icons-logos-google-playstore.svg"
                      />
                      <span class="footer-app-store-text">{{
                        "FOOTER-PLAY-STORE-TEXT" | globalTranslate
                      }}</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row pe-5 py-5" style="padding-left: 2.3rem">
      <div class="page-info col-md-6">
        <h2 class="footer-mobile-app-title">
          {{ "FOOTER-DID-YOU-KNOW-TITLE" | globalTranslate }}
        </h2>
        <div class="before-border ms-1 mt-4 mb-2">
          <p class="small ps-2 footer-mobile-app-sub-head">
            {{ "FOOTER-DID-YOU-KNOW-TEXT" | globalTranslate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>